import { AttachFile } from "@mui/icons-material";
import { Box, TextField, Typography } from "@mui/material";
import AdvancedInputField from "components/UI/AdvancedInputField/AdvancedInputField";
import React, { useEffect, useRef, useState } from "react";

const NumberFieldWithUpload = ({
  options,
  submittedAnswer,
  responseAnswer,
  isFrom,
  handleQuesAnswer,
  questionType,
  event,
  comment,
  linkageAnswer,
  calculation,
  question,
}) => {
  
  const [value, setValue] = useState("");
  const [commentBox, setCommentBox] = useState("");
  const [file, setFile] = useState(null);

  const inputRef = useRef(null);

  // Initialize state once from submittedAnswer or calculation
  useEffect(() => {
    if (!!calculation?.custom_calculation_logic) {
      setValue(calculation?.resolved_custom_calculation_logic || "");
    } else if (submittedAnswer?.length > 0) {
      setValue(linkageAnswer || submittedAnswer?.[0]?.value || "");
      setFile(submittedAnswer?.[0]?.document || null);
      setCommentBox(submittedAnswer?.[0]?.comment || "");
    }
  }, [submittedAnswer, calculation, linkageAnswer]);

  const handleUpdate = ({ type, data }) => {
    let newValue = value;
    let newComment = commentBox;
    let newFile = file;

    if (type === "value") newValue = setValue(data.replace(/\D/g, "")) || data;
    else if (type === "comment") newComment = setCommentBox(data) || data;
    else if (type === "file") newFile = setFile(data) || data;

    if (isFrom === "taskSection") {
      handleQuesAnswer({
        obj: {
          value: type === "value" ? data.replace(/\D/g, "") : value,
          document: type === "file" ? data : file,
          weightage: 1,
          comment: type === "comment" ? data : commentBox,
        },
        realQuestion: question,
      });
    }
  };

  const placeholderSize = {
    inputProps: { sx: { fontSize: "14px" } },
  };
  const labelSize = { style: { fontSize: "14px" } };

  return (
    <Box
      mt={2}
      sx={{
        pointerEvents: isFrom === "publishedSurvey" ? "none" : "auto",
      }}
    >
      <TextField
        style={{ pointerEvents: event }}
        label="Numeric Value"
        disabled={!!calculation?.custom_calculation_logic}
        variant="outlined"
        fullWidth
        value={value}
        onChange={(e) => handleUpdate({ type: "value", data: e.target.value })}
        inputProps={{
          inputMode: "numeric",
          pattern: "[0-9]*",
        }}
        size="small"
        InputLabelProps={labelSize}
        InputProps={placeholderSize}
      />

      <Box mt={2}>
        {!!calculation?.custom_calculation_logic &&
          calculation?.resolved_custom_calculation_logic && (
            <Typography>
              Answer to this question has already been calculated, You can
              submit it directly*
            </Typography>
          )}
        {!!calculation?.custom_calculation_logic &&
          !calculation?.resolved_custom_calculation_logic && (
            <Typography>
              Answer to this question will be calculated automatically*
            </Typography>
          )}
      </Box>

      <Box
        width="100%"
        style={{
          margin: "26px 5px",
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
        }}
        onClick={() => inputRef.current?.click()}
      >
        <AttachFile
          style={{ backgroundColor: "#ced4da", padding: 4 }}
          color="disabled"
        />

        {submittedAnswer?.length > 0 &&
        (isFrom === "submissionSection" || isFrom === "approvalSection") ? (
          <Box border={1} borderRadius={4} p={1} borderColor="#cececece" ml={2}>
            {submittedAnswer?.[0]?.documentUrl === null ||
            submittedAnswer?.[0]?.files[0]?.url === null ? (
              <Typography variant="body2">
                No document has been uploaded
              </Typography>
            ) : (
              <a
                href={
                  submittedAnswer?.[0]?.documentUrl?.url ||
                  submittedAnswer?.[0]?.files[0]?.url
                }
                target="_blank"
                rel="noreferrer"
                style={{ color: "#999" }}
              >
                {submittedAnswer?.[0]?.documentUrl?.name ||
                  submittedAnswer?.[0]?.files[0]?.name}
              </a>
            )}
          </Box>
        ) : (
          <>
            <input
              name="actUpload"
              id="contained-button-activityFile"
              type="file"
              accept=".pdf"
              ref={inputRef}
              onChange={(e) =>
                handleUpdate({ type: "file", data: e.target.files[0] })
              }
              style={{ display: "none", pointerEvents: event }}
              multiple
            />
            <div
              style={{
                borderBottom: "2px solid #ced4da",
                marginLeft: 20,
                width: "100%",
                fontSize: "14px",
              }}
            >
              {file?.name || "Upload file"}
            </div>
          </>
        )}
      </Box>

      {comment && (
        <Box style={{ pointerEvents: event, marginTop: "10px" }}>
          <AdvancedInputField
            name="comment"
            data={commentBox}
            placeholder="Contributor's comment"
            handleChange={({ name, value }) =>
              handleUpdate({ type: name, data: value })
            }
          />
        </Box>
      )}
    </Box>
  );
};

export default NumberFieldWithUpload;
